// Get file extension from URL
export const getFileExtension = (url: string) => {
  const extension = url.split('.').pop()
  return extension ? extension.toLowerCase() : ''
}
